/**
 * this file contains all redux-saga watchers & workers for the documents
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Paul on 20/5/19
 */

import {takeEvery, call, put, takeLatest} from 'redux-saga/effects'
import {delay} from 'redux-saga'

import C from '../constants'
import config from '../config'
import {request, isEmpty, substitute} from '../utility/utilities'

// import action creators
import * as DocumentsActions from '../actions/documentsActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE DOC SIGN LINK
----------------------------------------------------------------------------- */

// watcher saga for fetching the doc sign link
export function* watchFetchDocumentsData() {
    yield takeLatest(C.FETCH_DOCUMNENTS_DATA, workerFetchDocumentsData)
}

// worker saga for fetching the funds documents
function* workerFetchDocumentsData(member_id) {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = substitute(config.endpoints.documentListURL, { member_id: member_id.payload })

    try {
        // show the loader
        yield put(DocumentsActions.showDocumentsLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if (!isEmpty(response.data.document_tree)) {
            // set the doc sign link
            yield put(DocumentsActions.showDocumentsData(response.data.document_tree))
        }

    } catch (error) {
        console.log(error)
    } finally {
        yield put(DocumentsActions.showDocumentsLoader(false))
    }
}

// watcher saga for deleting a document
export function* watchDeleteDocument() {
    yield takeLatest(C.DELETE_DOCUMENT, workerDeleteDocument)
}

// worker saga for fetching the funds documents
function* workerDeleteDocument(action) {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    const requestURL = substitute(config.endpoints.documentDeleteURL, { member_id: action.payload.member_id, document_id: action.payload.document_id })
    
    try {
        // get the response promise object
        const response = yield call(request, requestURL, headers)
        yield put(DocumentsActions.getDocumentsData(action.payload.member_id))

    } catch (error) {

    } finally {
        
    }    
}

// watcher saga for fetching the document categories
export function* watchFetchDocumentCategories() {
    yield takeEvery(C.FETCH_DOC_CATEGORIES, workerFetchDocumentCategories)
}

// worker saga for fetching the member documents
function* workerFetchDocumentCategories() {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.memberDocumentCategoriesFetchURL

    try {
        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if (!isEmpty(response.data)) {
            // set the member doc details
            yield put(DocumentsActions.setDocumentCategories(response.data))
        }

    } catch (error) {
        console.log('error')
    }
}

// watcher saga for fetching the docusign envelope data
export function* watchFetchDocusignData() {
    yield takeEvery(C.GET_DOCUSIGN_DATA, workerFetchDocusignData)
}

// worker saga for fetching the docusign envelope data
function* workerFetchDocusignData(action) {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }


    // Grab the payload
    let member_id = action.payload

    // set the endpoint
    const requestURL = substitute(config.endpoints.docusignListDocuments, { id: action.payload })
    
    let data = false
    let attemptCounter = 0

    while (!data && attemptCounter < 5) { //if docusign is not ready try again in 10 second until is done

        try {
            // get the response promise object
            const response = yield call(request, requestURL, headers)

            if (!isEmpty(response.data)) {
                data = true
                
                // set the doc sign link
                yield put(DocumentsActions.setDocusignData(response.data))
            }
            else if (response.status === 204) {
                yield delay(10000);
            }

        } catch (error) {
            console.log(error)
            yield delay(10000);

        } finally {
            attemptCounter++
        }
    }
}


// WEBPACK FOOTER //
// ./src/sagas/documentsSaga.js